import { Directive, Input, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[task]',
})
export class TaskDirective {
  @Input() id;
  constructor(public viewContainerRef: ViewContainerRef) {}
}
